var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDataFeeds = function SvgDataFeeds(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#data-feeds_svg__a)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.429,
    d: "M9.286 3.571v32.858"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#data-feeds_svg__b)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.429,
    d: "M15 3.571v32.858"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#data-feeds_svg__c)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.429,
    d: "M20.715 3.571v32.858"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#data-feeds_svg__d)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.429,
    d: "M26.429 3.571v32.858"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.429,
    d: "M3.571 10.714H15"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M3.572 19.286a.714.714 0 0 0 0 1.428zm33.362 1.22a.714.714 0 0 0 0-1.011l-4.546-4.546a.714.714 0 0 0-1.01 1.01L35.418 20l-4.04 4.04a.714.714 0 0 0 1.01 1.01zM3.572 20v.714h32.857v-1.428H3.572z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.429,
    d: "M3.571 27.857h17.143"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "data-feeds_svg__a",
    x1: 8.544,
    x2: 2.593,
    y1: 34.101,
    y2: 33.648,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D92E7F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "data-feeds_svg__b",
    x1: 14.258,
    x2: 8.308,
    y1: 34.101,
    y2: 33.648,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D92E7F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "data-feeds_svg__c",
    x1: 19.973,
    x2: 14.022,
    y1: 34.101,
    y2: 33.648,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D92E7F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "data-feeds_svg__d",
    x1: 25.687,
    x2: 19.736,
    y1: 34.101,
    y2: 33.648,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D92E7F"
  })))));
};
export default SvgDataFeeds;